import _slicedToArray from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

/* eslint-disable @typescript-eslint/ban-types */
import React, { useState } from 'react';
import styled from 'styled-components';
import { Icon } from '../icon';
import { Sidebar } from '../sidebar';
import { makeDropdownComponent, makeDropdownBackdrop, makeDropdownToggle, makeDropdownCollapse, makeMenuContainer, makeMenuItems, makeMenuItem, makeMenuLink, makeMenuDivider, makeDropdownCloseButton } from './mixins';
import { useWindowSize } from '../../hooks/window-size';
var DropdownComponent = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function () {
  return makeDropdownComponent();
});
var DropdownBackdrop = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeDropdownBackdrop(props);
});
var DropdownToggle = styled.button(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), function () {
  return makeDropdownToggle();
});
var DropdownCollapse = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeDropdownCollapse(props);
});
var MenuContainer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeMenuContainer(props);
});
var MenuItems = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeMenuItems(props);
});
var MenuItem = styled.span(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeMenuItem(props);
});
var MenuLink = styled.a(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeMenuLink(props);
});
var MenuDivider = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return makeMenuDivider(props);
});
var DropdownCloseButton = styled.button(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  ", "\n"])), function () {
  return makeDropdownCloseButton();
});

var ItemList = function ItemList(props) {
  var _props$dropdownHeader = props.dropdownHeader,
      dropdownHeader = _props$dropdownHeader === void 0 ? null : _props$dropdownHeader,
      items = props.items,
      dropdownKey = props.dropdownKey,
      _props$skin = props.skin,
      skin = _props$skin === void 0 ? 'new-skin' : _props$skin,
      onClickHandler = props.onClickHandler,
      _props$dropdownFooter = props.dropdownFooter,
      dropdownFooter = _props$dropdownFooter === void 0 ? null : _props$dropdownFooter,
      _props$maxHeight = props.maxHeight,
      maxHeight = _props$maxHeight === void 0 ? 'auto' : _props$maxHeight;
  return React.createElement(MenuContainer, {
    skin: skin
  }, dropdownHeader && dropdownHeader, React.createElement(MenuItems, {
    maxHeight: maxHeight,
    skin: skin
  }, items.length > 0 && items.map(function (item) {
    return React.createElement(MenuItem, {
      key: "".concat(dropdownKey, "-item-").concat(item.key),
      skin: skin
    }, item.divider ? React.createElement(MenuDivider, {
      skin: skin
    }) : React.createElement(MenuLink, Object.assign({
      href: item.href,
      id: item.id
    }, item.props, {
      onClick: function onClick(e) {
        return onClickHandler ? onClickHandler(e, item) : null;
      },
      skin: skin
    }), item.before, item.content, item.after && item.after));
  })), dropdownFooter && dropdownFooter);
};

var SidebarMenu = function SidebarMenu(props) {
  var show = props.show,
      closeType = props.closeType,
      toggleDropdownContent = props.toggleDropdownContent;
  return React.createElement(Sidebar, {
    closeType: closeType,
    visible: show,
    position: props.position,
    handleClose: toggleDropdownContent
  }, React.createElement(ItemList, Object.assign({}, props)));
};

var DropdownMenu = function DropdownMenu(props) {
  var show = props.show,
      _props$position = props.position,
      position = _props$position === void 0 ? 'left' : _props$position,
      _props$closeButton = props.closeButton,
      closeButton = _props$closeButton === void 0 ? true : _props$closeButton,
      closeDropdownContent = props.closeDropdownContent,
      _props$skin2 = props.skin,
      skin = _props$skin2 === void 0 ? 'new-skin' : _props$skin2,
      _props$maxHeight2 = props.maxHeight,
      maxHeight = _props$maxHeight2 === void 0 ? 'auto ' : _props$maxHeight2;
  return show && React.createElement(DropdownCollapse, {
    position: position,
    skin: skin,
    maxHeight: maxHeight
  }, closeButton && React.createElement(DropdownCloseButton, {
    onClick: function onClick() {
      return closeDropdownContent();
    }
  }, React.createElement(Icon, {
    name: "icon-light-close",
    color: "rgba(0, 0, 24, 0.84)",
    size: "24"
  })), React.createElement(ItemList, Object.assign({}, props)));
};

export var Dropdown = function Dropdown(props) {
  var _props$visible = props.visible,
      visible = _props$visible === void 0 ? false : _props$visible,
      _props$dropdownKey = props.dropdownKey,
      dropdownKey = _props$dropdownKey === void 0 ? 'dropdown' : _props$dropdownKey,
      children = props.children,
      _props$callback = props.callback,
      callback = _props$callback === void 0 ? function () {
    return null;
  } : _props$callback,
      _props$maxHeight3 = props.maxHeight,
      maxHeight = _props$maxHeight3 === void 0 ? 'auto' : _props$maxHeight3;

  var _useWindowSize = useWindowSize(),
      isMobile = _useWindowSize.isMobile,
      isTabletPortrait = _useWindowSize.isTabletPortrait;

  var _useState = useState(visible),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var onClickHandler = function onClickHandler(e, item) {
    e.preventDefault();
    if (callback) callback(item);
    if (item && item.href) window.location.href = item.href;
  };

  var toggleDropdownContent = function toggleDropdownContent() {
    setShow(!show);
  };

  var closeDropdownContent = function closeDropdownContent() {
    setShow(false);
  };

  return React.createElement(DropdownComponent, Object.assign({}, props, {
    key: "".concat(dropdownKey, "-dropdown")
  }), React.createElement(DropdownToggle, {
    onClick: function onClick() {
      return toggleDropdownContent();
    }
  }, children), isMobile || isTabletPortrait ? React.createElement(SidebarMenu, Object.assign({}, props, {
    withArrow: false,
    closeType: "close",
    show: show,
    toggleDropdownContent: toggleDropdownContent,
    onClickHandler: onClickHandler
  })) : React.createElement(DropdownMenu, Object.assign({}, props, {
    show: show,
    closeDropdownContent: closeDropdownContent,
    maxHeight: maxHeight
  })), show && !isMobile && !isTabletPortrait && React.createElement(DropdownBackdrop, {
    onClick: function onClick() {
      return closeDropdownContent();
    }
  }));
};